import React from 'react';
import MovementDiffLines from './MovementDiffLines';

/**
 * Title + optional stacked movement diffs or single-line subtitle.
 */
export default function CareerTimelineEventBody({
  title,
  subtitle,
  details = [],
  subtitleClassName = 'text-gray-600',
}) {
  return (
    <>
      <div className="text-sm font-semibold text-gray-900">{title}</div>
      {details.length > 0 ? (
        <div className="mt-1.5">
          <MovementDiffLines diffs={details} />
        </div>
      ) : (
        subtitle ? (
          <div className={`text-xs mt-1 ${subtitleClassName}`}>{subtitle}</div>
        ) : null
      )}
    </>
  );
}
